import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useQueryParam, StringParam } from 'use-query-params';
import { Box, ButtonGroup, Link } from '@material-ui/core';
import apiRoutes from '../../../config/api/routes';
import { useI18nPath } from '../../../config/clientRoutes/hooks';
import {
  ResetPasswordRequest,
  ResetPasswordResponse,
} from '../../../config/api/models/ResetPassword';
import { useFetch } from '../../shared';
import {
  Button,
  Paragraph,
  Icons,
  FormControl,
  Message,
  TextFieldAdapter,
  validations,
} from '../../shared/components';
import theme from 'src/config/theme';
import { baseName } from 'src';

const ResetPasswordForm = () => {
  const [resetPasswordResponse, resetPassword] = useFetch<
    ResetPasswordResponse,
    ResetPasswordRequest
  >(apiRoutes.resetPassword(), {
    method: 'POST',
  });
  const { t } = useTranslation();
  const { getPath } = useI18nPath();
  const { push } = useHistory();
  const booksPath = getPath('sso');
  const loginPath = getPath('login');
  const [token] = useQueryParam('forgot_password_token', StringParam);

  useEffect(() => {
    if (resetPasswordResponse.success) {
      const basePath = baseName ? `${baseName}/` : '';

      if (resetPasswordResponse.data.token) {
        const absoluteURL = new URL(
          `${basePath}${booksPath}?token=${resetPasswordResponse.data.token}`,
          window.location.origin
        ).href;
        window.location.href = absoluteURL;
      } else {
        const absoluteURL = new URL(loginPath, window.location.origin).href;

        setTimeout(() => {
          window.location.href = absoluteURL;
        }, 0);
      }
    }
  }, [resetPasswordResponse, booksPath, loginPath]);

  return token ? (
    <Form
      onSubmit={(values) => {
        resetPassword({
          body: {
            token,
            password: values.password,
          },
        });
      }}
      initialValues={{
        token: token,
        password: '',
        confirmPassword: '',
      }}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <Paragraph>Je wachtwoord moet minimaal 8 tekens bevatten.</Paragraph>
          <FormControl label={t('shared.forms.password')} id="password" required>
            <Field
              name="password"
              component={TextFieldAdapter}
              validate={validations(t).isValidPassWord}
              type="password"
            />
          </FormControl>
          <FormControl
            label={t('shared.forms.passwordConfirmation')}
            id="passwordConfirmation"
            required
          >
            <Field
              name="passwordConfirmation"
              component={TextFieldAdapter}
              validate={validations(t).match(values.password)}
              type="password"
            />
          </FormControl>
          <ButtonGroup style={{ width: '100%' }}>
            <Button type="submit" icon={Icons.SUBMIT} style={{ width: 'inherit' }}>
              {t('shared.forms.confirm')}
            </Button>
          </ButtonGroup>
          {resetPasswordResponse && resetPasswordResponse.error && (
            <Message type="error">{t('shared.errors.generic')}</Message>
          )}
          <Paragraph style={{ marginTop: '4rem' }} align="justify">
            We staan voor je klaar bij aanmeldproblemen.{' '}
            <Link
              href={'https://www.lernova.be/contact'}
              underline="always"
              style={{ color: theme.palette.ternary.main }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Neem contact op.
            </Link>
          </Paragraph>
        </form>
      )}
    />
  ) : (
    <>
      <Box mb={3}>
        <Message type="error">{t('shared.errors.resetPasswordNoToken')}</Message>
      </Box>
      <Button onClick={() => push(loginPath)}>{t('security.resetPassword.toLoginBtn')}</Button>
    </>
  );
};

export default ResetPasswordForm;
